import { useMutation } from "urql";

import { CreateMessageTemplateDocument } from "../../../../graphql/generated.ts";

export function useCreateMessageTemplate() {
  return useMutation(CreateMessageTemplateDocument);
}
